export default {
    book_now: 'Jetzt buchen',
    minimum_age: 'Mindestalter {age} Jahre',
    excess_liability: 'Haftpflichtversicherung mit Ausfalldeckung',
    security_deposit: 'Kaution',
    fuel_policy: 'Treibstoff-Richtlinie',
    like_for_like: 'LFL',
    full_to_full: 'Voll abholen, voll abgeben',
    miles_per_rental: '{mileage} kostenlosen Meilen pro Mietwagen',
    km_per_rental: '{mileage} kostenlosen km pro Mietwagen',
    unlimited_mileage: 'Unbegrenzte Reichweite',
    unlimited_mileage_km: 'Unbegrenzte km',
    non_amendable: 'Nicht ergänzungsfähig',
    non_refundable: 'Nicht erstattbar',
    free_cancellation_until: 'Kostenlose Stornierung bis',
    cancellation_in_line_with: 'Stornierung in Übereinstimmung mit',
    tcs: 'AGBs',
    free_extras_on_collection: 'Zwei Gratis-Extras bei Abholung',
    glass_and_tyres_covered: 'Glas und Reifen versichert',
    number_of_passengers: 'Anzahl der Passagiere',
    number_of_bags: 'Anzahl der Gepäckstücke',
    fuel_type: 'Treibstoffart',
    co2: 'CO2',
    aircon: 'Klimaanlage',
    transmission: 'Übersetzung',
    book_type: '{type} buchen',
    debit_card_deposit: 'Debitkarte für Einzahlungen akzeptiert',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/de/quotes/price_card.js